import React from "react";
import TableBase from "./Base";
import moment from "moment";

import { DATE_FORMAT_FRONTEND } from "../../constants";

const CompaniesTable = ({ scrollHeight, actionWidth, withAction, statuses, ...props }) => {
  const COLUMNS = [
    {
      title: "Company Name",
      dataIndex: "name",
      fixed: true,
      width: 150,
    },
    {
      title: "Created Date ",
      dataIndex: "createdAt",
      width: 150,
      render(value) {
        return value ? moment(value).format(DATE_FORMAT_FRONTEND) : "";
      },
    },
    {
      title: "Company Admin Email",
      dataIndex: "companyName",
      width: 300,
      ellipsis: true,
      render(_value, record) {
        return record.userAdmin?.email || "-";
      },
    },
    {
      title: "# of Company Admins",
      dataIndex: "totalCompanyAdmins",
      width: 150,
      render(value) {
        return value || 0;
      },
    },
    {
      title: "# of Drivers",
      dataIndex: "totalOfDrivers",
      width: 150,
      render(value) {
        return value || 0;
      },
    },
    {
      title: "# of User Groups",
      dataIndex: "totalUserGroups",
      width: 150,
      render(value) {
        return value || 0;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 150,
      render(value) {
        return <div style={{ color: statuses[value] ? statuses[value]["color"] : "" }}>{statuses[value]["label"]}</div>;
      },
    },
  ];

  if (withAction) {
    COLUMNS.push({
      key: "action",
      width: actionWidth || 100,
      fixed: "right",
      render(record) {
        return withAction(record);
      },
    });
  }

  if (scrollHeight) {
    return <TableBase columns={COLUMNS} scroll={{ x: 991, y: scrollHeight }} {...props} />;
  } else {
    return <TableBase columns={COLUMNS} scroll={{ x: 991 }} {...props} />;
  }
};

export default CompaniesTable;
